/**
 * The below file contains the constants used in the Lightning Non Inmates Registration
 * @author: vishal.mishra@velsof.com
 * @date :22-01-2025
 */

export const GET_ALL_LIGHTNING_NON_INMATES_REGISTRATION =
  "GET_ALL_LIGHTNING_NON_INMATES_REGISTRATION";
export const SET_ALL_LIGHTNING_NON_INMATES_REGISTRATION =
  "SET_ALL_LIGHTNING_NON_INMATES_REGISTRATION";

export const REPORT_DATE_PARAM = "reportDate";
export const STATUS_PARAM = "status";
export const GET_ALL_CREATE_LIGHTNING_NON_INMATES_REGISTRATION =
  "GET_ALL_CREATE_LIGHTNING_NON_INMATES_REGISTRATION";
export const SET_ALL_CREATE_LIGHTNING_NON_INMATES_REGISTRATION =
  "SET_ALL_CREATE_LIGHTNING_NON_INMATES_REGISTRATION";

export const GET_ALL_UPDATE_LIGHTNING_NON_INMATES_REGISTRATION =
  "GET_ALL_UPDATE_LIGHTNING_NON_INMATES_REGISTRATION";
export const SET_ALL_UPDATE_LIGHTNING_NON_INMATES_REGISTRATION =
  "SET_ALL_UPDATE_LIGHTNING_NON_INMATES_REGISTRATION";

export const SET_LIGHTNING_NON_INMATES_REGISTRATION =
  "SET_LIGHTNING_NON_INMATES_REGISTRATION";

/**Constants for relief camp Import page */
export const NON_CAMP_INMATES_REGISTRATION_IMPORT =
  "LIGHTNING_NON_CAMP_INMATES_REGISTRATION_IMPORT";
export const NON_CAMP_INMATES_REGISTRATION_IMPORT_EXCEL =
  "LIGHTNING_NON_CAMP_INMATES_REGISTRATION_IMPORT_EXCEL";
/**Constants for relief camp Import page */

/**Constants for camp inmates registration export */
export const GET_EXPORT_NON_CAMP_INMATES_DATA =
  "LIGHTNING_GET_EXPORT_NON_CAMP_INMATES_DATA";
export const SET_EXPORT_NON_CAMP_INMATES_DATA =
  "LIGHTNING_SET_EXPORT_NON_CAMP_INMATES_DATA";
